import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StandardReportUIHelpers";

const StandardReportUIContext = createContext();

export function useStandardReportUIContext() {
  return useContext(StandardReportUIContext);
}

export const StandardReportUIConsumer = StandardReportUIContext.Consumer;

export function StandardReportUIProvider({ standardReportParameters, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    term: standardReportParameters.term,
    date: standardReportParameters.date,
    dateEnd: standardReportParameters.dateEnd,
    sectionId: standardReportParameters.sectionId,
    studentId: standardReportParameters.studentId
  };

  return (
    <StandardReportUIContext.Provider value={value}>
      {children}
    </StandardReportUIContext.Provider>
  );
}